import React, { useState, useEffect} from "react";


import "../Styles-css/Service.css"; 
import houseImg from "../Image/11.jpg";
import houseImg1 from "../Image/12.jpg";
import houseImg2 from "../Image/13.jpg";
import houseImg3 from "../Image/14.jpg";
import houseImg4 from "../Image/15.jpg";
import houseImg5 from "../Image/16.jpg";


const Service=()=>{
  const [showMore, setShowMore] = useState(false);
  const [showMoreCommercial, setShowMoreCommercial] = useState(false);
  const [showMoreShop, setShowMoreShop] = useState(false);
  const [showMoreTownship, setShowMoreTownship] = useState(false);
  const [showMoreVilla, setShowMoreVilla] = useState(false);
  const [showMoreWarehouse, setShowMoreWarehouse] = useState(false);

  const apartments_features = [
    <p className="house-content-p"><span className="highlight">Security –</span> All properties come with 24/7 security, CCTV surveillance, and gated entry.</p>,
    <p className="house-content-p"><span className="highlight">Prime Location –</span> Apartments in top localities near markets, schools, hospitals.</p>,
    <p className="house-content-p"><span className="highlight">Spacious Area –</span> Choose from 1BHK, 2BHK, 3BHK with good ventilation.</p>,
    <p className="house-content-p"><span className="highlight">Parking Facility –</span> Dedicated car and bike parking for residents and guests.</p>,
    <p className="house-content-p"><span className="highlight">Green Garden Spaces –</span> Landscaped gardens and relaxation zones.</p>,
    <p className="house-content-p"><span className="highlight">Temple Access –</span> Nearby temples for your daily prayers.</p>,
    <p className="house-content-p"><span className="highlight">Power Backup –</span> Continuous electricity and lift backup.</p>,
    <p className="house-content-p"><span className="highlight">Water Supply –</span> 24/7 water from borewell/municipal sources.</p>,
    <p className="house-content-p"><span className="highlight">Modern Interiors –</span> Furnished/semi-furnished with modular kitchens.</p>,
    <p className="house-content-p"><span className="highlight">Affordable Rent –</span> Flexible pricing with no hidden charges.</p>,
    <p className="house-content-p"><span className="highlight">Pet-Friendly Options –</span> Some allow pets with special pet zones.</p>,
    <p className="house-content-p"><span className="highlight">On-Demand Maintenance –</span> Quick help for plumbing, electrical, etc.</p>,
    <p className="house-content-p"><span className="highlight">Connectivity –</span> High-speed internet, cable TV provisions.</p>,
    <p className="house-content-p"><span className="highlight">Family & Bachelor Friendly –</span> Suitable options for all needs.</p>,
    <p className="house-content-p"><span className="highlight">Easy Documentation –</span> Hassle-free rental paperwork.</p>,
    <p className="house-content-p"><span className="highlight">Customer Support –</span> 24/7 chat and phone assistance.</p>,
    <p className="house-content-p"><span className="highlight">Verified Listings –</span> Checked for authenticity and safety.</p>,
    <p className="house-content-p"><span className="highlight">Community Amenities –</span> Clubhouse, gym, pools, kids area.</p>,
    <p className="house-content-p"><span className="highlight">Short & Long-Term Rentals –</span> Flexible stay options.</p>,
    <p className="house-content-p"><span className="highlight">Nearby Essentials –</span> Access to grocery, ATMs, delivery.</p>,
  ];
  const commercial_features =[
    <p className="house-content-p"><span className="highlight">Security –</span>24/7 Security  Guarded premises with CCTV and access control systems for total safety.</p>,
    <p className="house-content-p"><span className="highlight">Prime Business Locations – </span>Offices and shops in high-visibility areas, near main roads and transit hubs.</p>,
    <p className="house-content-p"><span className="highlight">Flexible Area Options – </span>Choose from compact units to large commercial floors (200–10,000+ sq. ft).</p>,
    <p className="house-content-p"><span className="highlight">Conference Room/Reception –</span>Optional spaces for meetings, client interaction, and admin use.</p>,
    <p className="house-content-p"><span className="highlight">Easy Paperwork –</span>Hassle-free agreements, licensing, and registration support.</p>,
    <p className="house-content-p"><span className="highlight">Furnishing Options –</span>Bare shell, semi-furnished, or fully furnished commercial setups.</p>,
    <p className="house-content-p"><span className="highlight">Lift Access –</span> High-speed elevators and service lifts in multi-floor commercial buildings.</p>,

  ]
  const solo_shop_features = [
    <p className="house-content-p"><span className="highlight">Prime Retail Locations –</span> Shops located in markets, malls, main roads, and high footfall areas.</p>,
    <p className="house-content-p"><span className="highlight">Compact to Spacious Options –</span> Sizes ranging from 100 to 1000+ sq. ft. to fit all retail needs.</p>,
    <p className="house-content-p"><span className="highlight">Front-Facing Visibility –</span> Road-facing or entrance-facing with great signage exposure.</p>,
    <p className="house-content-p"><span className="highlight">Shutter Security –</span> Roll-up shutter with lock system for safety and ease of use.</p>,
    <p className="house-content-p"><span className="highlight">Dedicated Electricity –</span> Separate power meter with commercial electricity connection.</p>,
    <p className="house-content-p"><span className="highlight">Display-Friendly Interiors –</span> Open layout for racks, counters, and customer movement.</p>,
    <p className="house-content-p"><span className="highlight">Storage Area –</span> Small back room or loft space for storing extra inventory.</p>,
    <p className="house-content-p"><span className="highlight">Customer Parking –</span> Nearby or front-side parking space for walk-in clients.</p>,
    <p className="house-content-p"><span className="highlight">High Foot Traffic –</span> Located in busy markets or connected to anchor stores/malls.</p>,
    <p className="house-content-p"><span className="highlight">Water Connection –</span> Basic water supply for utility needs.</p>,
    <p className="house-content-p"><span className="highlight">Restroom Access –</span> Attached or shared washroom facility depending on the property.</p>,
    <p className="house-content-p"><span className="highlight">Affordable Rent –</span> Budget-friendly rental options ideal for small businesses.</p>,
    <p className="house-content-p"><span className="highlight">Ready-to-Move –</span> Shop spaces available immediately with basic fittings.</p>,
    <p className="house-content-p"><span className="highlight">Essential Services Nearby –</span> Close to ATMs, courier, delivery, and food joints.</p>,
    <p className="house-content-p"><span className="highlight">Digital Signage Support –</span> Electrical points for boards, LED screens, or lighting.</p>,
    <p className="house-content-p"><span className="highlight">Flexible Lease Options –</span> Monthly, annual, and kiosk-style rental plans.</p>,
    <p className="house-content-p"><span className="highlight">Easy Documentation –</span> Quick rental agreements and shop license support.</p>,
    <p className="house-content-p" ><span className="highlight">Verified Listings –</span> All shops inspected and approved for commercial use.</p>,
    <p className="house-content-p"><span className="highlight">24/7 Support –</span> Get help for booking, questions, and issue resolution anytime.</p>
  ];
  const township_features = [
    <p className="house-content-p"><span className="highlight">Gated Community Security –</span> 24/7 guards, CCTV surveillance, and smart access systems at all entry/exit points.</p>,
    <p className="house-content-p"><span className="highlight">Integrated Township –</span> Residential, commercial, retail, and recreational zones within one planned layout.</p>,
    <p className="house-content-p"><span className="highlight">Wide Road Infrastructure –</span> Broad internal roads with footpaths, street lights, and roundabouts for smooth flow.</p>,
    <p className="house-content-p"><span className="highlight">Green Spaces –</span> Landscaped parks, gardens, and walking trails for a peaceful living environment.</p>,
    <p className="house-content-p"><span className="highlight">Clubhouse & Community Hall –</span> Dedicated spaces for events, functions, indoor games, and meetings.</p>,
    <p className="house-content-p"><span className="highlight">Sports Facilities –</span> Cricket pitch, basketball court, tennis court, gym, and jogging tracks.</p>,
    <p className="house-content-p"><span className="highlight">Educational Institutions –</span> Schools, playgroups, and daycare centers inside or very close to the township.</p>,
    <p className="house-content-p"><span className="highlight">Healthcare Access –</span> In-house clinic or nearby hospitals with emergency care and pharmacies.</p>,
    <p className="house-content-p"><span className="highlight">Shopping Convenience –</span> Supermarkets, salons, ATMs, and daily need stores within walking distance.</p>,
    <p className="house-content-p"><span className="highlight">Ample Parking –</span> Allocated parking for residents and separate visitor parking areas.</p>,
    <p className="house-content-p"><span className="highlight">Religious Centers –</span> Temple, mosque, or church located inside or near the premises.</p>,
    <p className="house-content-p"><span className="highlight">24/7 Utilities –</span> Continuous water supply and power backup in both homes and common areas.</p>,
    <p className="house-content-p"><span className="highlight">Waste Management –</span> Organized garbage collection and eco-friendly waste disposal practices.</p>,
    <p className="house-content-p"><span className="highlight">Eco-Friendly Design –</span> Solar lights, rainwater harvesting, and vastu-compliant planning.</p>,
    <p className="house-content-p"><span className="highlight">Pet-Friendly –</span> Safe pathways and designated pet areas for dog walks and playtime.</p>,
    <p className="house-content-p"><span className="highlight">Kids Play Zones –</span> Safe playgrounds with slides, swings, and soft flooring for children.</p>,
    <p className="house-content-p"><span className="highlight">Modern Architecture –</span> Aesthetic buildings with smart layouts and premium finishes.</p>,
    <p className="house-content-p"><span className="highlight">Wi-Fi Zones –</span> High-speed internet and shared Wi-Fi access in select common areas.</p>,
    <p className="house-content-p"><span className="highlight">Banking & ATM –</span> On-site ATMs and mini-bank branches for resident convenience.</p>,
    <p className="house-content-p"><span className="highlight">Public Transport Access –</span> Close to metro stations, bus stops, or township shuttle service.</p>,
    <p className="house-content-p"><span className="highlight">Festival Spaces –</span> Central lawns or event areas for celebrating cultural and festive occasions.</p>,
    <p className="house-content-p"><span className="highlight">Quick Maintenance Support –</span> 24/7 support team for plumbing, electrical, and emergency needs.</p>
  ];
  const villa_features = [
    <p className="house-content-p"><span className="highlight">Private Security –</span> 24/7 security with personal gated access, CCTV, and alarm systems for each villa.</p>,
    <p className="house-content-p"><span className="highlight">Spacious Living –</span> Independent units with multiple floors, balconies, terraces, and large living areas.</p>,
    <p className="house-content-p"><span className="highlight">Private Garden –</span> Dedicated landscaped garden or lawn area with outdoor seating space.</p>,
    <p className="house-content-p"><span className="highlight">Parking Facility –</span> Covered car parking within the villa premises for multiple vehicles.</p>,
    <p className="house-content-p"><span className="highlight">Exclusive Terrace –</span> Open rooftop for evening relaxation, parties, or personal use.</p>,
    <p className="house-content-p"><span className="highlight">Luxury Interiors –</span> Premium finishing, modular kitchens, woodwork, and elegant flooring.</p>,
    <p className="house-content-p"><span className="highlight">Private Pool (Optional) –</span> Select villas come with a private swimming pool or plunge pool.</p>,
    <p className="house-content-p"><span className="highlight">Servant/Utility Room –</span> Additional quarters for staff or utility storage included in layout.</p>,
    <p className="house-content-p"><span className="highlight">Air Conditioning –</span> Central or split ACs pre-installed in bedrooms and living areas.</p>,
    <p className="house-content-p"><span className="highlight">Power Backup –</span> Inverter or generator support for uninterrupted power.</p>,
    <p className="house-content-p"><span className="highlight">Water Supply –</span> 24/7 water supply with personal storage tanks or borewell access.</p>,
    <p className="house-content-p"><span className="highlight">Pet-Friendly –</span> Open spaces and fenced areas suitable for pets and outdoor activities.</p>,
    <p className="house-content-p"><span className="highlight">Green Surroundings –</span> Villas surrounded by trees and peaceful, pollution-free environment.</p>,
    <p className="house-content-p"><span className="highlight">Temple Nearby –</span> Easy access to spiritual centers or personal pooja room in villa.</p>,
    <p className="house-content-p"><span className="highlight">Smart Home Features –</span> Automation-ready for lights, cameras, and access systems (in select units).</p>,
    <p className="house-content-p"><span className="highlight">Modern Bathrooms –</span> Designer fittings, bathtub/shower cubicle, and high-end fixtures.</p>,
    <p className="house-content-p"><span className="highlight">Luxury Lifestyle –</span> Ideal for families who seek privacy, space, and comfort.</p>,
    <p className="house-content-p"><span className="highlight">Clubhouse Access –</span> Entry to shared society amenities like gym, pool, and sports courts.</p>,
    <p className="house-content-p"><span className="highlight">Easy Connectivity –</span> Well-connected to city centers, schools, malls, and hospitals.</p>,
    <p className="house-content-p"><span className="highlight">Custom Design Options –</span> Scope to personalize interiors or add floors (subject to approval).</p>
  ];
  const warehouse_features = [
    <p className="house-content-p"><span className="highlight">24/7 Security –</span> Secured premises with guard patrols, CCTV surveillance, and gated access control.</p>,
    <p className="house-content-p"><span className="highlight">Spacious Units –</span> Warehouses ranging from 1,000 sq. ft. to 50,000+ sq. ft. for various storage and industrial needs.</p>,
    <p className="house-content-p"><span className="highlight">Loading/Unloading Bays –</span> Dock-level loading/unloading platforms for easy truck movement and goods handling.</p>,
    <p className="house-content-p"><span className="highlight">Ample Parking –</span> Dedicated space for trucks, transport vehicles, and staff vehicles.</p>,
    <p className="house-content-p"><span className="highlight">High Ceilings –</span> 18-30 ft ceiling height ideal for vertical storage and stacking of goods.</p>,
    <p className="house-content-p"><span className="highlight">Heavy Load Flooring –</span> Industrial-grade RCC flooring for machinery, pallets, and forklifts.</p>,
    <p className="house-content-p"><span className="highlight">Power Supply –</span> High-tension electricity connection suitable for industrial and commercial use.</p>,
    <p className="house-content-p"><span className="highlight">Water Connection –</span> Continuous water supply for cleaning, staff use, and operational needs.</p>,
    <p className="house-content-p"><span className="highlight">Fire Safety –</span> Fire extinguishers, sprinklers, smoke detectors, and emergency exits as per safety norms.</p>,
    <p className="house-content-p"><span className="highlight">Office Space –</span> Built-in or optional administrative office cabin within or next to the warehouse.</p>,
    <p className="house-content-p"><span className="highlight">Internet & Communication –</span> Connectivity for CCTV, IoT devices, and office use.</p>,
    <p className="house-content-p"><span className="highlight">Ventilation –</span> Natural light, cross-ventilation, and exhaust systems for fresh air circulation.</p>,
    <p className="house-content-p"><span className="highlight">Staff Amenities –</span> Restrooms, changing rooms, drinking water, and sitting areas for workers.</p>,
    <p className="house-content-p"><span className="highlight">Flexible Lease Terms –</span> Short-term and long-term leasing options with scalable space availability.</p>,
    <p className="house-content-p"><span className="highlight">Custom Build Options –</span> Build-to-suit or modification support as per business requirements (on request).</p>,
    <p className="house-content-p"><span className="highlight">Easy Truck Access –</span> Wide roads for container movement and 24/7 loading flexibility.</p>,
    <p className="house-content-p"><span className="highlight">Strategic Location –</span> Close to highways, industrial zones, ports, or logistics hubs.</p>,
    <p className="house-content-p"><span className="highlight">Verified Property –</span> Legal clearance, compliance with local warehousing and industrial norms.</p>,
    <p className="house-content-p"><span className="highlight">Affordable Rent –</span> Competitive rental pricing with clear documentation and no hidden charges.</p>,
    <p className="house-content-p"><span className="highlight">Maintenance Support –</span> On-call repair services for electrical, structural, or plumbing issues.</p>
  ];
   
    return(
        <>
         <div className="container">
         <div className="hero-container">
            <div className="hero-overlay">
            <h3 className="head-title">Our Services</h3>
              <h3 className="trust-badge">MOST TRUSTED</h3>
              <h1 className="hero-title">
              Properties for rent that fit your timeline              
              </h1>
              
              <div className="stats"> 
                <span className="stats-pro">🏠 Over 2M Properties</span>
                <span  className="stats-pro">😀 46,789 people happy</span>
                <span  className="stats-pro">⭐⭐⭐⭐⭐ 4.8 Top rated by People</span>
              </div>
            </div>
          </div>

          <div className="house-service">
                <div className="house-image">
                  <img src={houseImg} alt="House" />
                </div>
            <div className="house-content">
                <h2>Apartment Rent Service</h2>
                <h3>Comfortable Living with All Premium Amenities</h3>
                
                {(showMore ? apartments_features : apartments_features.slice(0, 3)).map((item, index) => (
                  <div key={index}>{item}</div>
                ))}

                <button
                  onClick={() => setShowMore(!showMore)}
                  className="read-more-btn"
                  style={{
                    color: "#4B0082",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "0",
                    marginTop: "10px",
                    fontWeight: "bold"
                  }}
                >
                  {showMore ? "Read Less.." : "Read More.."}
                </button>
                <div className="house-buttons">
                <a href="tel:+917898622741" className="btn call-btn">Call Now</a>
                <a href="https://wa.me/message/S75PHV2OQNM3P1" target="_blank" rel="noopener noreferrer" className="btn whatsapp-btn">
                  WhatsApp
                </a>
              </div>
            </div>
        </div>

        <div className="house-service">
          <div className="house-image">
            <img src={houseImg1} alt="House" />
          </div>
          <div className="house-content">
            <h2>SmartSpace Rentals</h2>
            <h3>Find Your Perfect Commercial Space – Hassle-Free, Affordable, Reliable</h3>
            {(showMoreCommercial ? commercial_features : commercial_features.slice(0, 3)).map((item, index) => (
                  <div key={index}>{item}</div>
                ))}

                <button
                  onClick={() => setShowMoreCommercial(!showMoreCommercial)}
                  className="read-more-btn"
                  style={{
                    color: "#4B0082",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "0",
                    marginTop: "10px",
                    fontWeight: "bold"
                  }}
                >
                  {showMoreCommercial? "Read Less.." : "Read More.."}
                </button>
            <div className="house-buttons">
              <a href="tel:+917898622741" className="btn call-btn">Call Now</a>
              <a
                href="https://wa.me/message/S75PHV2OQNM3P1"
                target="_blank"
                rel="noopener noreferrer"
                className="btn whatsapp-btn"
              >
                WhatsApp
              </a>
            </div>
          </div>
        </div>
        <div className="house-service">
          <div className="house-image">
            <img src={houseImg2} alt="House" />
          </div>
          <div className="house-content">
            <h2>Solo Shop – Rent Smarter, Live Better</h2>
            <h3>Your one-stop solution for hassle-free rentals.</h3>
            {(showMoreShop ? solo_shop_features : solo_shop_features.slice(0, 3)).map((item, index) => (
                  <div key={index}>{item}</div>
                ))}

                <button
                  onClick={() => setShowMoreShop(!showMoreShop)}
                  className="read-more-btn"
                  style={{
                    color: "#4B0082",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "0",
                    marginTop: "10px",
                    fontWeight: "bold"
                  }}
                >
                  {showMoreShop ? "Read Less.." : "Read More.."}
                </button>
            <div className="house-buttons">
              <a href="tel:+917898622741" className="btn call-btn">Call Now</a>
              <a
                href="https://wa.me/message/S75PHV2OQNM3P1"
                target="_blank"
                rel="noopener noreferrer"
                className="btn whatsapp-btn"
              >
                WhatsApp
              </a>
            </div>
          </div>
        </div>
        <div className="house-service">
          <div className="house-image">
            <img src={houseImg3} alt="House" />
          </div>
          <div className="house-content">
            <h2>Discover Premium Living in Our Modern Townships</h2>
            <h3>Find Your Perfect Rental Home with Comfort, Security & Style</h3>
            {(showMoreTownship ? township_features : township_features.slice(0, 3)).map((item, index) => (
                  <div key={index}>{item}</div>
                ))}

                <button
                  onClick={() => setShowMoreTownship(!showMoreTownship)}
                  className="read-more-btn"
                  style={{
                    color: "#4B0082",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "0",
                    marginTop: "10px",
                    fontWeight: "bold"
                  }}
                >
                  {showMoreTownship ? "Read Less.." : "Read More.."}
                </button>
            <div className="house-buttons">
              <a href="tel:+917898622741" className="btn call-btn">Call Now</a>
              <a
                href="https://wa.me/message/S75PHV2OQNM3P1"
                target="_blank"
                rel="noopener noreferrer"
                className="btn whatsapp-btn"
              >
                WhatsApp
              </a>
            </div>
          </div>
        </div>
        <div className="house-service">
          <div className="house-image">
            <img src={houseImg4} alt="House" />
          </div>
          <div className="house-content">
            <h2>Luxury Villas for Rent</h2>
            <h3>Find Your Perfect Escape in a Dream Villa</h3>
            {(showMoreVilla ? villa_features : villa_features.slice(0, 3)).map((item, index) => (
                  <div key={index}>{item}</div>
                ))}

                <button
                  onClick={() => setShowMoreVilla(!showMoreVilla)}
                  className="read-more-btn"
                  style={{
                    color: "#4B0082",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "0",
                    marginTop: "10px",
                    fontWeight: "bold"
                  }}
                >
                  {showMoreVilla ? "Read Less.." : "Read More.."}
                </button>
            <div className="house-buttons">
              <a href="tel:+917898622741" className="btn call-btn">Call Now</a>
              <a
                href="https://wa.me/message/S75PHV2OQNM3P1"
                target="_blank"
                rel="noopener noreferrer"
                className="btn whatsapp-btn"
              >
                WhatsApp
              </a>
            </div>
          </div>
        </div>
        <div className="house-service">
          <div className="house-image">
            <img src={houseImg5} alt="House" />
          </div>
          <div className="house-content">
            <h2>Reliable & Secure Warehouse Rentals</h2>
            <h3>Flexible Storage Solutions for Every Business</h3>
            {(showMoreWarehouse ? warehouse_features : warehouse_features.slice(0, 3)).map((item, index) => (
                  <div key={index}>{item}</div>
                ))}

                <button
                  onClick={() => setShowMoreWarehouse(!showMoreWarehouse)}
                  className="read-more-btn"
                  style={{
                    color: "#4B0082",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "0",
                    marginTop: "10px",
                    fontWeight: "bold"
                  }}
                >
                  {showMoreWarehouse ? "Read Less.." : "Read More.."}
                </button>
            <div className="house-buttons">
              <a href="tel:+917898622741" className="btn call-btn">Call Now</a>
              <a
                href="https://wa.me/message/S75PHV2OQNM3P1"
                target="_blank"
                rel="noopener noreferrer"
                className="btn whatsapp-btn"
              >
                WhatsApp
              </a>
            </div>
          </div>
        </div>
         </div>
        
        </>
    )
}
export default Service;

